import { IUser, IUserCustomProperties } from "../core/contracts/IUser";

export default class UserCustomProperty {
    static getUserCustomProperties(user: IUser | Partial<IUser> | null | undefined) {
        if (!user) {
            return null;
        }
        const customProperties: IUserCustomProperties = user.custom_properties && JSON.parse(user.custom_properties);
        return customProperties;
    }

    static getUserCustomPropertyValue(user: IUser | Partial<IUser> | null | undefined, property: keyof IUserCustomProperties) {
        const customProperties: IUserCustomProperties | null = this.getUserCustomProperties(user);
        return customProperties ? customProperties[property] : customProperties;
    }
}
